<template>
  <b-container>
    <div>
      <base-row-detail :label="'Id'" :value="value.id"></base-row-detail>
      <base-row-detail :label="'Ativo'" :value="value.active"></base-row-detail>
    </div>
    <b-row>
      <b-col>
        <b-form-group label="Status" label-for="input-process-displayName">
          <b-form-select
            class="status"
            :options="statusOptions"
            v-model="statusId"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- <span class="text-danger ml-3" v-if="modelstate['StatusId']">
      {{ modelstate["StatusId"][0] }}
    </span> -->
    <div v-for="item in value.values" :key="item.fieldId" class="fields">
      <!-- {{ item }} -->
      <workflow-fill-field
        :field="item"
        :fieldId="item.fieldId"
        :modelstate="modelstate"
        :stage="false"
      >
      </workflow-fill-field>
      <!-- <div
        v-for="additionalField in getListAdditionalField(item)"
        :key="additionalField.fieldId"
      >
        <workflow-fill-field
          :field="additionalField"
          :fieldId="additionalField.fieldId"
          :modelstate="modelstate"
          :stage="false"
        >
        </workflow-fill-field>
      </div> -->
    </div>
    <!-- Campos adicionais da etapa -->
    <b-row v-for="field in value.additionalFields" :key="field.fieldId">
      <b-col>
        <workflow-fill-field
          :field="field"
          :fieldId="field.fieldId"
          :modelstate="modelstate"
          :stage="true"
        >
        </workflow-fill-field>
        <!-- <div
          v-for="additionalField in getListAdditionalField(field)"
          :key="additionalField.fieldId"
        >
          <workflow-fill-field
            :field="additionalField"
            :fieldId="additionalField.fieldId"
            :modelstate="modelstate"
            :stage="false"
          >
          </workflow-fill-field>
        </div> -->
      </b-col>
    </b-row>

    <!-- <pre class="language-json"><code>{{ value  }}</code></pre> -->
    <!-- <pre
      class="language-json"
    ><code>value.additionalFields{{ value.additionalFields  }}</code></pre> -->
    <!-- <pre class="language-json"><code>value: {{ value  }}</code></pre> -->
  </b-container>
</template>

<script>
import AwesomeMask from "awesome-mask";
export default {
  name: "ProcessFilledDetailCrud",
  props: {
    value: Object,
    modelstate: Object,
  },
  components: {
    BaseRowDetail: () => import("@/components_rms/base/BaseRowDetail.vue"),
    WorkflowFillField: () =>
      import("@/components_rms/workflow/WorkflowFillField.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  created() {
    this.getstatusOptions();
    this.statusId = this.value.statusId;
    if (this.value.type == 7 || this.value.type == 13) this.getOptions();
  },
  data() {
    return {
      options: [],
      statusOptions: [],
      statusId: 0,
    };
  },
  methods: {
    getstatusOptions() {
      this.$apiWorkflow
        .get("/stage/allStage/" + this.value.processId)
        .then((response) => {
          this.statusOptions = response.data;
        });
    },
    getOptions() {
      if (!this.value) return;
      if (!this.value.valueList) return;
      this.value.valueList.forEach((item) => {
        this.options.push({
          value: item.id,
          text: item.text,
        });
      });
    },
    getAdditionalFields() {
      if (!this.value) return;
      if (!this.value.id) return;
      if (!this.value.statusId) return;
      this.$apiWorkflow
        .get("/addtionalFields/" + this.value.statusId + "/" + this.value.id)
        .then((response) => {
          let additionalFieldsNew = [];
          let additionalFieldsResponse = response.data;
          if (additionalFieldsResponse) {
            for (let additionalField of additionalFieldsResponse) {
              if (
                !this.value.values.some(
                  (e) => e.fieldId == additionalField.fieldId
                )
              ) {
                additionalFieldsNew.push(additionalField);
              }
            }
          }
          this.value.additionalFields = additionalFieldsNew;
        });
    },
    // getListAdditionalField(field) {
    //   let fields = [];
    //   if (field.valueList != null) {
    //     for (let opt of field.valueList) {
    //       if (opt.id == field.value) {
    //         if (opt.values != null) {
    //           for (let aditionalField of opt.values) {
    //             fields.push(aditionalField);
    //           }
    //         }
    //       }
    //     }
    //   }
    //   return fields;
    // },
  },
  watch: {
    value() {
      this.statusId = this.value.statusId;
      this.getstatusOptions();
    },
    statusId() {
      this.value.statusId = this.statusId;
      this.getAdditionalFields();
    },
  },
};
</script>
<style scoped>
.status {
  width: 54%;
}
</style>